interface AboutLabelProps {
  text: string;
}

export function AboutLabel({ text }: AboutLabelProps) {
  return <p className="text-xs text-foreground">{text}</p>;
}
